import { motion } from "framer-motion";
import { images, manifesto } from "@/data/content";

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] } }),
};

export default function About() {
  return (
    <section id="sobre" className="relative py-24 md:py-32 bg-cream">
      <div className="mx-auto max-w-7xl px-5">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="mb-16 max-w-2xl"
        >
          <span className="inline-block rounded-full bg-brand-green/15 text-brand-green px-4 py-1.5 font-700 text-sm mb-4">
            Nossa história
          </span>
          <h2 className="font-display font-700 text-ink text-4xl md:text-5xl leading-tight">
            Educar é cuidar, acolher e caminhar junto de cada família.
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-12 gap-8 items-start">
          {/* Big photo */}
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="lg:col-span-5 lg:sticky lg:top-28"
          >
            <div className="relative rounded-[2rem] overflow-hidden shadow-[0_20px_60px_rgb(30,58,95,0.12)]">
              <img src={images.play} alt="Crianças brincando na Recriar" className="w-full h-[520px] object-cover" />
              <div className="absolute bottom-4 left-4 right-4 rounded-2xl bg-white/90 backdrop-blur-md px-5 py-4">
                <p className="font-display font-600 text-ink text-lg">Desde 2019</p>
                <p className="font-body text-ink-soft text-sm">Uma trajetória construída com carinho e responsabilidade.</p>
              </div>
            </div>
            <img
              src={images.baby}
              alt="Berçário — bebê brincando"
              data-testid="about-baby-photo"
              className="absolute -top-8 -right-6 h-36 w-28 md:h-44 md:w-36 rounded-3xl object-cover border-[6px] border-cream shadow-[0_16px_40px_rgb(30,58,95,0.18)] rotate-3 hidden sm:block"
            />
          </motion.div>

          {/* Manifesto */}
          <div className="lg:col-span-7 space-y-5">
            {manifesto.map((m, i) => {
              const colors = ["#FF9ECE", "#45B7D1", "#FFE66D", "#FF9F1C"];
              const c = colors[i % colors.length];
              return (
                <motion.div
                  key={m.n}
                  custom={i}
                  variants={reveal}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, margin: "-60px" }}
                  className="group relative rounded-3xl bg-white p-8 shadow-[0_8px_30px_rgb(30,58,95,0.05)] hover:shadow-[0_16px_44px_rgb(30,58,95,0.1)] hover:-translate-y-1 transition-all duration-300 border-l-[6px]"
                  style={{ borderColor: c }}
                  data-testid={`manifesto-${m.n}`}
                >
                  <div className="flex items-start gap-5">
                    <span className="font-display font-700 text-4xl shrink-0" style={{ color: c }}>{m.n}</span>
                    <div>
                      <h3 className="font-display font-600 text-ink text-xl mb-1">{m.title}</h3>
                      <p className="font-body text-ink-soft leading-relaxed">{m.text}</p>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
